import { useEffect, useState } from 'react';

const TARGET_TIME = Date.UTC(2026, 6, 20, 2, 0, 0); // 12/06/2026 02:00 GMT+7 = 11/06/2026 19:00 UTC

const CountDownFinal = () => {
  const calculateTimeLeft = () => {
    const now = Date.now();
    const diff = TARGET_TIME - now;

    if (diff <= 0) {
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
        finished: true
      };
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
      finished: false
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // if (timeLeft.finished) {
  //   return (
  //     <div className="inline-flex flex-col items-center justify-center px-3 py-2 rounded-[14px] bg-[#fff] border border-[#f27121] shadow-[0_0_10px_rgba(0,0,0,0.45)]">
  //       <span className="text-[14px] md:text-[16px] font-medium text-[#f27121] uppercase tracking-wide">
  //         Vòng chung kết đang diễn ra
  //       </span>
  //     </div>
  //   );
  // }

  return (
    <div className="inline-flex gap-[4px] md:gap-[20px] items-center">
      {/* Days */}
      <div className="bg-[rgba(255,255,255,0.1)] flex flex-col h-[33.5px] md:h-[67px] items-center justify-center rounded-[4.46px] md:rounded-[8.927px] w-[48px] md:w-[96px] text-white text-center">
        <p className="font-bold text-[16px] md:text-[32px] leading-[16px] md:leading-[36px] m-0">
          {timeLeft.days}
        </p>
        <p className="font-medium text-[8px] md:text-[16px] leading-[12px] md:leading-[24px] m-0">
          ngày
        </p>
      </div>

      {/* Hours */}
      <div className="bg-[rgba(255,255,255,0.1)] flex flex-col h-[33.5px] md:h-[67px] items-center justify-center rounded-[4.46px] md:rounded-[8.927px] w-[48px] md:w-[96px] text-white text-center">
        <p className="font-bold text-[16px] md:text-[32px] leading-[16px] md:leading-[36px] m-0">
          {timeLeft.hours}
        </p>
        <p className="font-medium text-[8px] md:text-[16px] leading-[12px] md:leading-[24px] m-0">
          giờ
        </p>
      </div>

      {/* Minutes */}
      <div className="bg-[rgba(255,255,255,0.1)] flex flex-col h-[33.5px] md:h-[67px] items-center justify-center rounded-[4.46px] md:rounded-[8.927px] w-[48px] md:w-[96px] text-white text-center">
        <p className="font-bold text-[16px] md:text-[32px] leading-[16px] md:leading-[36px] m-0">
          {timeLeft.minutes}
        </p>
        <p className="font-medium text-[8px] md:text-[16px] leading-[12px] md:leading-[24px] m-0">
          phút
        </p>
      </div>

      {/* Seconds */}
      <div className="bg-[rgba(255,255,255,0.1)] flex flex-col h-[33.5px] md:h-[67px] items-center justify-center rounded-[4.46px] md:rounded-[8.927px] w-[48px] md:w-[96px] text-white text-center">
        <p className="font-bold text-[16px] md:text-[32px] leading-[16px] md:leading-[36px] m-0">
          {timeLeft.seconds}
        </p>
        <p className="font-medium text-[8px] md:text-[16px] leading-[12px] md:leading-[24px] m-0">
          giây
        </p>
      </div>
    </div>
  );
};

export default CountDownFinal;
